
import { IOrganization } from '@/types/projects'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'organization-proof-status'
})
export default class OrganizationProofStatus extends Vue {
  @Prop() organization!: IOrganization

  get label (): string {
    let labelHtml = '-'
    const expired = this.organization.is_proof_expired
    if (this.organization.is_proof_uploaded) {
      if (!expired) labelHtml = `<span class="badge badge-success">${this.$gettext('Valid')}</span>`
      else labelHtml = `<span class="badge badge-danger">${this.$gettext('Expired')}</span>`
    }
    return labelHtml
  }
}
